import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue";
import { onBeforeUnmount, ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'PresentationHost',
    props: {
        hosts: {},
        target: {}
    },
    setup(__props) {
        const props = __props;
        const host = ref();
        watch([() => props.hosts, () => props.target ?? host.value], ([hosts, target], [previousHosts, previousTarget]) => {
            if (previousTarget !== undefined && previousHosts !== undefined) {
                previousHosts.unregister(previousTarget);
            }
            if (target !== undefined) {
                hosts.register(target);
            }
        }, { flush: 'post', immediate: true });
        onBeforeUnmount(() => {
            const target = props.target ?? host.value;
            if (target !== undefined) {
                props.hosts.unregister(target);
            }
        });
        return (_ctx, _cache) => {
            return (__props.target !== undefined)
                ? (_openBlock(), _createBlock(_Teleport, {
                    key: 0,
                    to: __props.target,
                    defer: true
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 8, ["to"]))
                : (_openBlock(), _createElementBlock("div", _mergeProps({
                    key: 1,
                    ref_key: "host",
                    ref: host
                }, _ctx.$attrs, { "data-input-presentation-host": "" }), [
                    _renderSlot(_ctx.$slots, "default")
                ], 16));
        };
    }
});
